import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import baseQuery from "../../utils/baseQuery";
import { Zutat } from "../zutaten/zutatenConnector";
import { Einheit } from "../../utils/Einheit";

interface GerichtBase {
    id: number
    name: string
}

export interface Gericht extends GerichtBase {
    hatZutaten: boolean
}

export interface GerichtMitZutaten extends GerichtBase {
    zutaten: Array<{ id: number, menge: number, einheit: Einheit, zutat: Zutat }>
}

export const gerichteApi = createApi({
    reducerPath: "gerichte",
    baseQuery: baseQuery,
    tagTypes: ["gericht", "gerichte"],
    endpoints: builder => ({
        listGerichte: builder.query<Gericht[], void>({
            query: () => "gerichte/",
            providesTags: () => [{ type: "gerichte" }]
        }),
        getGericht: builder.query<GerichtMitZutaten, number>({
            query: id => `gerichte/${id}`,
            providesTags: result => result ? [{ type: "gericht", id: result.id }] : []
        }),
        addGerichtZutat: builder.mutation<void, {
            gerichtId: number,
            zutatId: number,
            menge: number,
            einheit: Einheit
        }>({
            query: ({ gerichtId, zutatId, menge, einheit }) => ({
                url: `gerichte/${gerichtId}/zutaten/${zutatId}`,
                params: { menge, einheit },
                method: "POST",
            }),
            invalidatesTags: (result, error, { gerichtId }) => [{ type: "gericht", id: gerichtId }]
        }),
        removeGerichtZutat: builder.mutation<void, { gerichtId: number, zutatId: number }>({
            query: ({ gerichtId, zutatId }) => ({
                url: `gerichte/${gerichtId}/zutaten/${zutatId}`,
                method: "DELETE",
            }),
            invalidatesTags: (result, error, { gerichtId }) => [{ type: "gericht", id: gerichtId }]
        }),
        addGericht: builder.mutation<Gericht, string>({
            query: name => ({
                url: `gerichte/`,
                params: { name },
                method: "POST",
            }),
            invalidatesTags: () => [{ type: "gerichte" }]
        }),
        setGerichtName: builder.mutation<void, { gerichtId: number, name: string }>({
            query: ({ gerichtId, name }) => ({
                url: `gerichte/${gerichtId}`,
                params: { name },
                method: "PUT"
            }),
            invalidatesTags: (result, error, { gerichtId }) => [{ type: "gerichte" }, { type: "gericht", id: gerichtId }]
        }),
        removeGericht: builder.mutation<void, number>({
            query: (gerichtId) => ({
                url: `gerichte/${gerichtId}`,
                method: "DELETE",
            }),
            invalidatesTags: (result, error, gerichtId) => [{ type: "gerichte" }, { type: "gericht", id: gerichtId }]
        }),
    })
});
export const { useGetGerichtQuery, useListGerichteQuery, useAddGerichtZutatMutation, useRemoveGerichtZutatMutation, useAddGerichtMutation, useSetGerichtNameMutation, useRemoveGerichtMutation } = gerichteApi;
